import { render, staticRenderFns } from "./AccessNiPolicy.vue?vue&type=template&id=f5d60fc2"
import script from "./AccessNiPolicy.vue?vue&type=script&lang=js"
export * from "./AccessNiPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports